var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('ModalVideoUpload'),_c('ModalPlugin',{attrs:{"videoIds":_vm.selectedVideos},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"tile":"","text":"","disabled":_vm.selectedVideos.length == 0}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s("mdi-plus"))]),_vm._v(" "+_vm._s(_vm.$t("modal.plugin.link"))+" ")],1)]}}])}),_c('UserMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }